module.exports = __webpack_public_path__ + "static/logo-with-aa-cb214e07455bccf405b9235688893d4b.svg";